import type { FunctionComponent } from 'react';

import { useBalance } from '../../../account/hooks/use-balance';
import { SideNavigationComponent } from '../../components/side-navigation/side-navigation';

export interface ITransactionsProps {
    className?: string;
    onCloseNav?: () => void;
}

export const SideNavigationContainer: FunctionComponent<ITransactionsProps> = ({
    className,
    onCloseNav,
}) => {
    const { wallets } = useBalance();

    return (
        <SideNavigationComponent className={className} wallets={wallets} onCloseNav={onCloseNav} />
    );
};
